import styled from "styled-components";
import React, { useEffect, useCallback, useState, useRef } from "react";
import { Icon, Label, Menu, Table } from 'semantic-ui-react'


const Factors = () =>{

    return (
        <Container>
            <Title>Predictive Analysis</Title>
            <Description>Below you'll find an analysis of culture factors as it relates to the archived tags associated with individuals who have completed the survey prior to leaving the organization.</Description>
            
        <TableContainer>
        <Table celled>
                <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>Department</Table.HeaderCell>
                    <Table.HeaderCell>Relative likelihood of resignation</Table.HeaderCell>
                </Table.Row>
                </Table.Header>

                <Table.Body>
                <Table.Row>
                    <Table.Cell>Department A</Table.Cell>
                    <Table.Cell><strong>3.2x</strong> more likely</Table.Cell>
                </Table.Row>
                <Table.Row>
                <Table.Cell>Department B</Table.Cell>
                    <Table.Cell><strong>2.5x</strong> more likely</Table.Cell>
                </Table.Row>
                <Table.Row>
                <Table.Cell>Department C</Table.Cell>
                    <Table.Cell><strong>1.3x</strong> more likely</Table.Cell>
                </Table.Row>

                <Table.Row>
                <Table.Cell>Department D</Table.Cell>
                    <Table.Cell><strong>1.2x</strong> less likely</Table.Cell>
                </Table.Row>

                <Table.Row>
                <Table.Cell>Department E</Table.Cell>
                    <Table.Cell><strong>1.3x</strong> less likely</Table.Cell>
                </Table.Row>

                <Table.Row>
                <Table.Cell>Department F</Table.Cell>
                    <Table.Cell><strong>2.2x</strong> less likely</Table.Cell>
                </Table.Row>

                <Table.Row>
                <Table.Cell>Department G</Table.Cell>
                    <Table.Cell><strong>3.2x</strong> less likely</Table.Cell>
                </Table.Row>


                </Table.Body>

            </Table>

        </TableContainer>
            
        </Container>
    )

}


export default Factors


const Container = styled.div`
    width: 100%;
    max-width:1000px;
`
const Title = styled.div`
    font-family: Raleway;
    font-size: 24px;
    font-style: normal;
    font-weight: bold;
    margin-bottom:24px;
`
const Description = styled.div`
font-family: Raleway;
font-size: 16px;
font-style: normal;
font-weight: 400;
max-width:800px;
line-height:1.5;
`
const ChartArea = styled.div`
    width:100%;
    margin-top:40px;
`
const TableContainer = styled.div`
    width:100%;
    font-family: Raleway;
    margin-top:20px;
`

const test_data = [
    {score:7.2,org_score:6.5,name:"Psychological Safety"},
    {score:6.2,org_score:6.5,name:"Adaptability"},
    {score:5.2,org_score:6.5,name:"Values"},
    {score:4.2,org_score:6.5,name:"Inclusivity"},
    {score:3.2,org_score:6.5,name:"Communication"},
    {score:2.2,org_score:6.5,name:"Impact"},
    {score:1.2,org_score:6.5,name:"Purpose"}
]